export default "__VITE_ASSET__0jQAMbkv__"